import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { GenericDetailPage, GenericFormPage } from '../../../components/generic';
import { useAccAccount, AccAccount } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges, getInitialFormData, mapItemToFormData } from './config';
import List from './List';

export { List };

export const Form: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const editId = id && id !== 'new' ? parseInt(id, 10) : NaN;
  const isEdit = Number.isInteger(editId);
  const { item, isLoading: loadingItem } = useAccAccount(isEdit ? editId : 0);

  const fieldDisabled = useMemo(() => {
    const childCount = item?._count?.children ?? 0;
    if (childCount > 0) return { isPosting: true };
    return undefined;
  }, [item?._count?.children]);

  const config = useMemo(() => {
    const base = { ...moduleConfig, getInitialFormData, mapItemToFormData };
    if (!isEdit) return base;
    return {
      ...base,
      formLayout: {
        ...base.formLayout,
        sections: base.formLayout.sections.map((section) => ({
          ...section,
          defaultCollapsed: false,
        })),
      },
    };
  }, [isEdit]);

  if (isEdit && loadingItem) {
    return (
      <div className="flex items-center justify-center flex-1 min-h-[240px] text-sm text-gray-500">
        Loading…
      </div>
    );
  }

  return <GenericFormPage<AccAccount> useData={useAccAccount} config={config} fieldDisabled={fieldDisabled} />;
};
export const Detail: React.FC = () => (
  <GenericDetailPage<AccAccount>
    useData={useAccAccount}
    config={{ ...moduleConfig, getDetailSections, getStatusBadges }}
  />
);
